import React, { Component } from 'react'
import configs from '../../../configs.json'


// <a className="waves-effect waves-light btn hoverable" style={{backgroundColor: configs.colors.secondary}}>comprar</a>

class Plans extends Component {
    constructor(props) {
        super(props)
        this.state = this.computeColors(props.colored, props.dark)
    }
    computeColors(colored, dark) {
        if (colored && dark) {
            return { colored, dark, backgroundColor: configs.colors.primary, text: configs.colors.light, color: configs.colors.dark }
        }
        if (!colored && !dark) {
            return { colored, dark, color: configs.colors.primary, text: configs.colors.dark, backgroundColor: configs.colors.light }
        }
        if (!colored && dark) {
            return { colored, dark, color: configs.colors.primary, text: configs.colors.light, backgroundColor: configs.colors.dark }
        }
        return { colored, dark, backgroundColor: configs.colors.primary, text: configs.colors.dark, color: configs.colors.light }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.colored !== this.props.colored || prevProps.dark !== this.props.dark) {
            this.setState(this.computeColors(this.props.colored, this.props.dark))
        }
    }
    render() {
        return (
            <div className='container' style={{backgroundColor: this.state.backgroundColor}} id='plans'>
                <div className='row section-row'>
                    <h3 style={{color: this.state.color}}>Planos</h3>
                    <h6 style={{color: this.state.text}}>Escolha o plano que mais combina com você</h6>
                    <br></br>
                    <div className='row section-row'>
                    {configs.plans.map((p) =>
                    <div className={'col s12 m3'} key={p.name}>
                        <div className='card-panel' style={{backgroundColor: configs.colors.offwhite}}>
                            <h5>{p.name}</h5>
                            <p>
                                {p.price !== null
                                    ? <>R$ <span style={{color: configs.colors.secondary, fontSize: '2.12rem', fontWeight: 400}}>{p.price}</span> / Mês</>
                                    : <span style={{color: configs.colors.secondary, fontSize: '1.4rem', fontWeight: 400}}>Sob consulta</span>
                                }
                            </p>
                            <p style={{color: configs.colors.dark}}>
                                {p.minutes !== null
                                    ? <><strong>{p.minutes} min</strong> / mês incluídos</>
                                    : <strong>Minutos ilimitados</strong>
                                }
                            </p>
                            {configs.services.map((s) =>
                                <p key={`${p.name}-${s.name}`}>{s.name}</p>
                            )}
                            {p.overage && p.minutes !== null && (
                                <p style={{fontSize: '0.85rem', color: configs.colors.secondary}}>
                                    Excedente: R$0,25/min
                                </p>
                            )}
                        </div>
                    </div>
                    )}
                    </div>
                </div>
            </div>
        )
    }
}

export default Plans